import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ComputPage from '@/components/ComputePage.vue';
import ComputeWizardClamping from '@/components/ComputeWizard/ComputeWizardClamping.vue';
import { RoutePath } from '@/enums/Router';
import { useComputeWizardStore } from '@/store/computeWizard';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComputeClampingPage',
  setup(__props) {

const computeWizardStore = useComputeWizardStore();

const runMainCalculation = () => {
  computeWizardStore.updateFinalResult();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ComputPage, {
    class: "compute-clamping-page",
    "prev-url": _unref(RoutePath).COMPUTE_STEP_QUALITY,
    "next-url": _unref(RoutePath).HOME,
    title: _ctx.$t('home.steps.clamping.label'),
    "current-step": 5,
    onOnNextStep: runMainCalculation,
    "update-final-result-on-close": ""
  }, {
    default: _withCtx(() => [
      _createVNode(ComputeWizardClamping)
    ]),
    _: 1
  }, 8, ["prev-url", "next-url", "title"]))
}
}

})